/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [page-not-found.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 10.01.20, 10:51
 */

import React from 'react';
import {Link} from 'react-router-dom';
import {useLanguage} from "../configuration/configuration";
import {useQueryParams} from "../hooks/use-query-params";

const PageNotFound = () => {
    const {message, status, error} = useQueryParams('message', 'status', 'error');
    const Lang = useLanguage();

    return <div className='page-not-found-container'>
        <div className='page-not-found-body'>
            <div className='teaser'>404</div>
            <div className='message'>{Lang.pageNotFound.text}
                {message && <div className='message-small'>{message}</div>}
                {error && <div className='message-small'>{error}</div>}
            </div>
        </div>
        <div className='page-not-found-link'>
            <span>{Lang.pageNotFound.back}</span>
            <Link to='/'>{Lang.errorPage.home}</Link>
        </div>
    </div>
};

export default PageNotFound;